/**
 *
 * Der HistoryController läuft über events.
 * Das ist leider keine gute Idee. Ständig muss man aufpassen, ob der Event vom Historycontroller ausgelöst wurde.
 * Ausserdem werden einige Informationen über das globalsObject geholt.
 *
 * Besser wäre, wenn der History Controller Ein Interface bereitstellen würde, in dem ein Actor selbst eintragen kann, wie man das was er
 * gerade tut rückgängig machen kann.
 * Dann bräuchte man auch die ganzen unterschiedlichen HistoryStep Klassen nicht.
 *
 * Ausserdem ist das Interface IHistoryStep mit den ganzen SelOb Sachen belastet, die die ganzen anderen Steps nicht brauchen.
 * Auch den SelObController bräuchte man nicht mehr.
 */


import {trackPageview} from "../globalsObject";

import {SelObController} from "../controllerModules/selObController";
import {OwayoJSKonfiViewer} from "../owayoJSViewerWithSelObs";
import {CONSTANTS} from "../meta_data";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {PATTERN_EVENTNAMES} from "../pattern/patternFactory";
import {SelectableObject, StockLogo} from "../selectableObjects";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";
import {
    HistoryStepPatternColorChange,
    HistorystepPatternDeleted,
    HistorystepPatternInserted,
    HistoryStepPatternSize
} from "../pattern/patternhistorySteps";
import {Vector2} from "../delme_globals";
import {EventListener} from "@k/global/eventVerteiler";
import {arrayElementByKeyValue} from "@k/global/arrayHelper";
import {HistoryStepColorChange} from "./historyStepColorChange";
import {HistoryStepSelObChanged} from "./historyStepSelObChanged";
import {HistoryStepSelObInserted} from "./historyStepSelObInserted";
import {HistoryStepSelObRemoved} from "./historyStepSelObRemoved";
import {HistoryStepZOrderOperation} from "./historyStepZOrderOperation";
import {IHistoryStep} from "./IHistoryStep";
import {Color} from "../colorObject";
import {HistoryDesignChange} from "./historyDesignChange";
import {HistoryStep} from "./historyStep";

export interface IHistoryStepWithSelObs extends IHistoryStep {
    replaceId(origId: string, newId: string): void;

    cloneWasDeleted(origId: string, newId: string): void;
}

export class HistoryController extends EventListener{
    selObController: SelObController;
    type:string;
    viewer: OwayoJSKonfiViewer;
    busySteps: HistoryStep[];
    private static history: Array<IHistoryStep> = [];
    alreadyRecording = false;
    private static currentHistoryIndex = -1;
    colorCodes;
    private readonly NOTAVAILABLECLASS = "not_available";
    private static readonly UndoButtonIMGSource = "img/layout/one-step-back.svg";
    private static readonly RedoButtonIMGSource = "img/layout/one-step-forward.svg";
    private static readonly UndoButtonIMGSource_disabled = "img/layout/one-step-back_disabled.svg";
    private static readonly RedoButtonIMGSource_disabled = "img/layout/one-step-forward_disabled.svg";

    public static readonly UNDO_EVENT = "undoLastStepevent";
    public static readonly UNDO_WITHOUT_REDO_EVENT = "undoLastStepAndDeleteSaidStepEvent";

    constructor(selObController: SelObController, viewer: OwayoJSKonfiViewer) {
        super();
        this.selObController = selObController;
        this.type = "historyController";
        this.viewer = viewer;
        this.busySteps = [];
        this.initControllerEvents();
        this.setUndoRedoButtonReadyState();
        document.addEventListener('keydown', event => this.onKeyDown(event), true);
        HistoryController.getUndoButton().addEventListener("click", () => this.undoStep());
        HistoryController.getRedoButton().addEventListener("click", () => this.redoStep());
    }



    private replaceIdInSteps = (origId:string, newId:string) => HistoryController.history.forEach(step => step.replaceId(origId, newId));
    private static isSTRG_Z = (event:KeyboardEvent) => event.ctrlKey && !event.shiftKey && event.keyCode === CONSTANTS.KEYCODE.Z;
    private static isSTRG_SHIFT_Z = (event:KeyboardEvent) => event.ctrlKey && event.shiftKey && event.keyCode === CONSTANTS.KEYCODE.Z;
    private static isSTRG_Y = (event:KeyboardEvent) => event.ctrlKey && !event.shiftKey && event.keyCode === CONSTANTS.KEYCODE.Y;
    private static getUndoButton = () => document.getElementById("undo") as HTMLDivElement;
    private static getRedoButton = () => document.getElementById("redo") as HTMLDivElement;
    private static getUndoButtonIMG = () => document.querySelector("#undo img") as HTMLImageElement;
    private static getRedoButtonIMG = () => document.querySelector("#redo img") as HTMLImageElement;

    public getSelOb = (id:string) => this.selObController.getSelOb(id);
    public replaceIds = (idsToReplace:string[], newIds:string[]) => idsToReplace.forEach((id, index) => this.replaceIdInSteps(id, newIds[index]));
    public getCloneIds = (origId:string) => this.selObController.getCloneIdsForOrigId(origId);

    private initControllerEvents() {
        this
            .addEventListener("threeDModelLoadedEvent", () => this.clearHistory())
            .addEventListener("initColorsEvent", (data) => this.initColors(data.colorCodes))
            .addEventListener("colorChangedEvent", (data) => this.colorChangeHandler(data))
            .addEventListener("objectInteractionStartingEvent", (id) => this.objectInteractionStartHandler(id))
            .addEventListener("objectInteractionEndingEvent", (id) => this.objectInteractionEndHandler(id))
            .addEventListener("cloneCreatedEvent", (data) => HistoryController.history.forEach(step => step.cloneWasCreated(data.origId)))
            .addEventListener(SELOBEVENTNAMES.CLONE_DELETED, (data) => this.cloneDeletedHandler(data))
            .addEventListener("selObInsertedByUserEvent", (selOb) => this.appendSelObInsert(selOb))
            .addEventListener("selObAboutToBeDeletedByUserEvent", (selOb) => this.appendSelObRemove(selOb))
            .addEventListener("zOrderChangedEvent", (data) => this.appendZOrderOperation(data))
            .addEventListener(PATTERN_EVENTNAMES.SIZE_CHANGED, (data)=>this.appendPatternSizeChange(data) )
            .addEventListener(PATTERN_EVENTNAMES.COLOR_CHANGED, (data)=>this.appendpatternColorChange(data) )
            .addEventListener(PATTERN_EVENTNAMES.CREATED, (data:{ stockLogo: StockLogo; ignoreInHistory: boolean; baseColorValue:string })=>this.appendpatternInserted(data) )
            .addEventListener(PATTERN_EVENTNAMES.PATTERN_ABOUT_TO_BE_DELETED, (data)=>this.appendPatternDeleted(data))
            .addEventListener(HistoryController.UNDO_EVENT, ()=>this.undoStep())
            .addEventListener(HistoryController.UNDO_WITHOUT_REDO_EVENT, ()=>{
                this.undoStep();
                this.deleteLastStep();
            })
            .addEventListener("aboutToChangeDesignEvent", (data:{oldDesign:string, newDesign:string, byHistoryController?:boolean, logosThatWillBeDeleted:SelectableObject[]})=>{
                this.appendDesignChangeEvent(data);
            })
            .addEventListener(INTERFRAMEMESSAGES.LOGOUT_SUCCEEDED, ()=>this.clearHistory())
        ;
    }

    private initColors = (colorCodes:Color[]) => this.colorCodes = colorCodes.map(c => {
        return {colorCode: c.colorCode, colorHexValue: c.getValueAsHex()}
    })


    private colorChangeHandler(data) {
        if (!data.sentFromHistoryController && data.byUser !== "no") {
            this.appendcolorChange(data);
        }
    }

    private objectInteractionStartHandler(id) {
        if (this.alreadyRecording === true) {
            return;
        }
        if (this.selObController.model.entwurf.getSelOb(id) !== null) {
            const selOb = (this.selObController.model.entwurf.getSelOb(id) as SelectableObject).clone(true);
            this.alreadyRecording = true;
            this.appendSelObChange(selOb);
        }
    }

    private objectInteractionEndHandler(id) {
        if (!this.alreadyRecording) {
            return;
        }
        if (typeof (HistoryController.history[HistoryController.currentHistoryIndex]) === "undefined") {
            this.clearHistory();
            return;
        }
        this.alreadyRecording = false;
        HistoryController.history[HistoryController.currentHistoryIndex].setEndStateSelOb(id);
    }

    private cloneDeletedHandler(data) {
        const step = HistoryController.history[HistoryController.history.length - 1];
        if (this.alreadyRecording === false) {
            step.cloneWasDeleted(data.origId, data.cloneId);
        }
    }

    private static RedoAvailable() {
        return HistoryController.history[HistoryController.currentHistoryIndex+1] !== undefined;
    }

    private setUndoRedoButtonReadyState() {
        if (HistoryController.currentHistoryIndex < 0) {
            HistoryController.getUndoButton().classList.add(this.NOTAVAILABLECLASS);
            (HistoryController.getUndoButtonIMG() as HTMLImageElement).src = HistoryController.UndoButtonIMGSource_disabled;
        } else {
            HistoryController.getUndoButton().classList.remove(this.NOTAVAILABLECLASS);
            HistoryController.getUndoButtonIMG().src = HistoryController.UndoButtonIMGSource;
        }
        if(!HistoryController.RedoAvailable()) {
            HistoryController.getRedoButton().classList.add(this.NOTAVAILABLECLASS);
            (HistoryController.getRedoButtonIMG() as HTMLImageElement).src = HistoryController.RedoButtonIMGSource_disabled;
        } else {
            HistoryController.getRedoButton().classList.remove(this.NOTAVAILABLECLASS);
            HistoryController.getRedoButtonIMG().src = HistoryController.RedoButtonIMGSource;
        }
    }

    public clearHistory() {
        HistoryController.history.splice(0, HistoryController.history.length);
        HistoryController.currentHistoryIndex = -1;
        this.busySteps = [];
        this.alreadyRecording = false;
        this.setUndoRedoButtonReadyState();
    }

    private clearHistoryAfterCurrentIndex() {
        const clearIndex = HistoryController.currentHistoryIndex + 1;
        HistoryController.history.splice(clearIndex, HistoryController.history.length - clearIndex);
        // for (i = this.busySteps.length - 1; i > -1; i--) {
        //     if (this.busySteps[i] >= clearIndex) {
        //         this.busySteps.splice(i, 1);
        //     }
        // }
            }

    public addHistoryStep(historyStep:IHistoryStep) {
        this.clearHistoryAfterCurrentIndex();
        HistoryController.history.push(historyStep);
        HistoryController.currentHistoryIndex += 1;
        this.setUndoRedoButtonReadyState();
    }

    private appendSelObInsert(selOb: SelectableObject) {
        this.addHistoryStep(
            new HistoryStepSelObInserted(
                this,
                {
                    selOb: selOb,
                    viewDetails: this.getCameraAndModelSettings()
                }
            )
        );
    }

    private appendSelObRemove(selOb: SelectableObject) {
        this.addHistoryStep(
            new HistoryStepSelObRemoved(
                this,
                {
                    selOb: selOb,
                    viewDetails: this.getCameraAndModelSettings()
                }
            )
        );
    }

    private appendSelObChange(selOb: SelectableObject) {
        this.addHistoryStep(new HistoryStepSelObChanged(this, {
            selOb: selOb.clone(true),
            viewDetails: this.getCameraAndModelSettings()
        }));
    }

    private appendcolorChange(eventData:{colorCode:string, colorHexValue:string}) {

        const color = arrayElementByKeyValue(this.colorCodes, 'colorCode', eventData.colorCode);
        if (color === null) {
            return;
        }

        this.addHistoryStep(
            new HistoryStepColorChange(
                this,
                {
                    colorCode: eventData.colorCode,
                    colorHexValueOld: color.colorHexValue,
                    colorHexValueNew: eventData.colorHexValue
                }
            )
        );
        color.colorHexValue = eventData.colorHexValue;
    }

    private appendPatternSizeChange(eventData) {
        if(eventData.ignoreInHistory) {
            return;
        }
        this.addHistoryStep(new HistoryStepPatternSize(this, eventData));
    }

    private appendpatternColorChange(eventData) {
        if(eventData.ignoreInHistory) {
            return;
        }

        this.addHistoryStep(new HistoryStepPatternColorChange(this, eventData));
    }


    private appendpatternInserted(data: { stockLogo: StockLogo; ignoreInHistory?: boolean; baseColorValue:string }) {
        if(data.ignoreInHistory === true) {
            return;
        }
        this.addHistoryStep(new HistorystepPatternInserted(this, data));
    }

    private appendPatternDeleted(data: any) {
        if(data.ignoreInHistory === true) {
            return;
        }
        this.addHistoryStep(new HistorystepPatternDeleted(this, data));
    }

    private appendZOrderOperation(eventData) {
        if (eventData.byHistoryController) {
            return;
        }
        this.addHistoryStep(new HistoryStepZOrderOperation(
            this, {
                id: eventData.id,
                oldIndex: eventData.oldIndex,
                newIndex: eventData.newIndex,
                viewDetails: this.getCameraAndModelSettings()
            }
        ));
    }

    private appendDesignChangeEvent(eventData:{oldDesign:string, newDesign:string, byHistoryController?: boolean, logosThatWillBeDeleted:SelectableObject[]}) {
        if(eventData.byHistoryController) {
            return;
        }
        this.addHistoryStep(new HistoryDesignChange(this,eventData, this.getCameraAndModelSettings()))
    }



    private undoStep() {
        trackPageview("konfitrack-zurueck.htm");

        if (HistoryController.currentHistoryIndex < 0) {
            return;
        }

        const step = HistoryController.history[HistoryController.currentHistoryIndex];
        step.undo();
        HistoryController.currentHistoryIndex -= 1;
        this.setUndoRedoButtonReadyState();
    }
    private deleteLastStep() {
        if(HistoryController.currentHistoryIndex >= HistoryController.history.length-1) {
            return;
        }
        HistoryController.history.pop();
    }

    private redoStep() {
        if (HistoryController.currentHistoryIndex + 1 >= HistoryController.history.length) {
            return;
        }
        HistoryController.currentHistoryIndex += 1;
        const step = HistoryController.history[HistoryController.currentHistoryIndex];
        step.redo();
        this.setUndoRedoButtonReadyState();
    }

    private onKeyDown(event) {
        if (this.busySteps.length > 0) {
            return;
        }
        if (HistoryController.isSTRG_Z(event)) {
            this.undoStep();
        }
        if (HistoryController.isSTRG_SHIFT_Z(event)) {
            this.redoStep();
        }
        if (HistoryController.isSTRG_Y(event)) {
            this.redoStep();
        }
    }

    private getCameraAndModelSettings() {
        if (!this.viewer) {
            return null;
        }
        return {
            zoom: {
                factor: this.viewer.zoomController.getFactor(),
                origin: this.viewer.zoomController.getZoomOrigin(),
                target: this.viewer.zoomController.getTarget()
            },
            modelRotation: this.viewer.getModelRotation(),
            cameraPosition: this.viewer.cloneCameraPosition()
        };

    }

    public restoreCameraAndModelSettings(settings) {
        if (!this.viewer) {
            return;
        }
        this.viewer.zoomController.setOrigin(new Vector2(settings.zoom.origin.x, settings.zoom.origin.y));
        this.viewer.zoomController.setTarget(new Vector2(settings.zoom.target.x, settings.zoom.target.y));
        this.viewer.zoomController.setZoomLevel(settings.zoom.factor);
        this.viewer.updateModelRotation(settings.modelRotation.x, settings.modelRotation.y);
        this.viewer.camera.position.set(settings.cameraPosition.x, settings.cameraPosition.y, settings.cameraPosition.z);
    }


}